<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  watch: {
    $route(to, from) {
      document.title = to.meta.title || "LessAdmin";
    },
  },
};
</script>
<style>
.v-main,
html {
  background: #eceff1;
}
div.v-toolbar__content {
  height: 56px !important;
}
div.v-alert {
  border-radius: 5px !important;
}
a.header-link {
  text-decoration: none;
  cursor: pointer;
  font-weight: 400;
  color: #551738 !important;
}
.theme {
  background-color: #551738 !important;
  border-color: #551738 !important;
}
.theme-text {
  color: #551738 !important;
}
.save {
  background-color: #17553d !important;
  border-color: #17553d !important;
}
.save-text {
  color: #17553d !important;
}
.action {
  background-color: #99702d !important;
  border-color: #99702d !important;
}
.action-text {
  color: #99702d !important;
}
a.v-breadcrumbs__item {
  color: #551738 !important;
}
a.v-breadcrumbs__item--disabled {
  color: rgba(0, 0, 0, 0.38) !important;
}
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
.row-pointer
  > .v-data-table__wrapper
  > table
  > tbody
  > .v-data-table__empty-wrapper
  :hover {
  cursor: default;
}
</style>
